import { render, staticRenderFns } from "./MoleculeContentBlockText.vue?vue&type=template&id=080c7f54&"
import script from "./MoleculeContentBlockText.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentBlockText.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContentBlockText.vue?vue&type=style&index=0&id=080c7f54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports